module.exports = __webpack_public_path__ + "img/shinkarenko.b351bab2.png";